<div class="base-layer-selection">
    <div *ngFor="let base of baseLayers" [class.selected-layer]="base.selected" class="base-layer">
        <img [src]="base.icon" alt="" (click)="changeBaseLayer(base)" />
        <p>{{ base.displayName }}</p>
    </div>
</div>
